var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"dropdown-example-2"}},[_c('v-overflow-btn',{staticClass:"my-2",attrs:{"items":_vm.dropdown_icon,"label":"Overflow Btn w/ segmented","segmented":"","target":"#dropdown-example-2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }